import { useEffect, useRef, useState } from "react";
import EasytimerModule, { Timer as TimerType } from "easytimer.js";

// easytimer.js's UMD build gets mis-interopped by some bundlers, which resolve
// the default import to the whole CJS exports object instead of the Timer
// class itself. Unwrap `.default` when that happens so `new Timer()` works
// under both the broken and the correctly-interopped shape.
const Timer = (EasytimerModule as unknown as { default?: typeof TimerType }).default ?? EasytimerModule;

export function useTrackingTimer(startTimestamp?: string) {
    const timerRef = useRef<TimerType | null>(null);
    const [timeText, setTimeText] = useState<string>("00:00:00");

    useEffect(() => {
        if (!startTimestamp) return;

        const timer = new Timer();
        const startTime = new Date(startTimestamp).getTime();
        const elapsedSeconds = Math.max(0, Math.floor((Date.now() - startTime) / 1000));

        timer.start({ startValues: { seconds: elapsedSeconds } });
        setTimeText(timer.getTimeValues().toString());

        timer.addEventListener("secondsUpdated", () => {
            setTimeText(timer.getTimeValues().toString());
        });

        timerRef.current = timer;

        return () => {
            timer.stop();
        };
    }, [startTimestamp]);

    return timeText;
}